<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  props: {
    inventoryId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      mname: "consumablesclaim",
      key: "id",
      url: {
        //   get: '/admin/system/inventory',
        // add: '/admin/system/inventory',
        // add: '/admin/system/inventory/receive',
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "领用数量",
          name: "receiveNum",
          value: "",
          type: "number",
          max: 100,
          desc: "一次最多领用数量100",
          width: "400px",
          rules: [
            {
              required: true,
              trigger: "blur",
              message: "领用数量不能为空",
              type: "number",
            },
          ],
        },
        {
          label: "领用人",
          name: "receive",
          value: "",
          type: "input",
          rules: [{ required: true, message: "领用人不能为空", trigger: "blur" }],
        },
        {
          label: "领用科室",
          name: "deskId",
          value: "",
          type: "select",
          width: "240px",
          dropList: [],
        },
        // { label: "领用科室", name: "desk", value: "", type: "input" },
        { label: "备注", name: "remark", value: "", type: "textarea" },
      ],
      forms: {
        receiveNum: "",
        inventoryId: this.inventoryId,
      },
    };
  },
  created() {
    this.loadLevelData();
  },
  methods: {
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/inventory/receive`, q, "PUT")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
              }
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 2000);
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 2000);
            });
        }
      });
    },
    loadLevelData() {
      let q = {};
      $utils.api.load("/admin/system/desk/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.deskName;
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "deskId") {
              this.items[index]["dropList"] = dropList;
            }
          }
        }
      });
    },
  },
};
</script>
